import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import dynamic from 'next/dynamic';
import { useBreakpoint } from '@/lib/breakpoint.service';

const ProgressLoading = dynamic(
  () => import('@/components/comm/progress/Loading'),
);

const fadeIn = keyframes`
from { opacity: 0 }
to { opacity: 1 }
`;

const Container = styled.div<{ show: boolean }>`
position: fixed;
z-index: 10000;
top: 0;
left: 0;
display: ${({ show }) => show ? 'grid' : 'none'};
width: 100vw;
height: 100vh;
animation: ${fadeIn} 120ms ease;
background-color: rgba(256, 256, 256, .5);
place-items: center;
`;

const FullScreenLoading = ({ show }: { show: boolean }) => {
  const breakpoint = useBreakpoint();

  return (
    <Container show={show}>
      <ProgressLoading size={breakpoint !== 'lg' ? '20%' : ''} />
    </Container>
  );
};

export default FullScreenLoading;
